export class AssuntoCnj{
    id = 0;	
	codItem = '';
	codItemPai = '';
	tipoItem = '';
	nome = '';
	situacao = '';
	ativo: Boolean;
}